module.exports = "/_next/static/images/04-10e422bd552edac4e2e2ee5201afaafe.png";